import PropTypes from 'prop-types';
import { Typography } from '@figure/frontlib-gui';

const LI = ({ children, ...props }) => (
  <Typography.Body semanticElement="li" {...props}>
    {children}
  </Typography.Body>
);

LI.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LI;
